import VueGtag from 'vue-gtag'
import { Router } from 'vue-router'
import app from '@/main'

export default {
  init(id: string, router: Router) {
    if (!id) {
      return
    }

    app.use(
      VueGtag,
      {
        config: { id },
      },
      router
    )
  },
}
